import React from 'react';
import './WhyChooseOurPms.css';
import ExpandableCard from '../components/ExpandableCard';
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../LanguagePrefix';

function WhyChooseOurPms(props) {
  const { t } = useTranslation();
  const langPrefix = useLanguagePrefix();

  const {
    headerTitle,
    headerDescription,
    sectionTitle,
    sectionDescription,
    cards = [],
  } = props;

  return (
    <div className='d-flex justify-content-center why-choose-section'>
      <div className='page-content'>
        <div className='d-flex justify-content-between  gap-3 image-and-text'>
          <div
            className='col background-img-col'
            style={{
              backgroundImage: "url('/images/why-choose-our-pms.svg')",
              backgroundSize: 'cover',
            }}
          >
            <h3 style={{ color: '#fff' }}>{t(headerTitle)}</h3>
            <p style={{ color: '#fff' }}>{t(headerDescription)}</p>
            <a
              href={`${langPrefix}/contact-us/`}
              className='light-blue-filled-btn-small mt-3'
              style={{
                backgroundColor: '#22242A',
                color: '#fff',
                width: 'fit-content',
                textDecoration:'none'
              }}
            >
              <svg
                width='16'
                height='16'
                viewBox='0 0 20 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M1 4L8.89 9.26C9.21866 9.47928 9.6049 9.5963 10 9.5963C10.3951 9.5963 10.7813 9.47928 11.11 9.26L19 4M3 15H17C17.5304 15 18.0391 14.7893 18.4142 14.4142C18.7893 14.0391 19 13.5304 19 13V3C19 2.46957 18.7893 1.96086 18.4142 1.58579C18.0391 1.21071 17.5304 1 17 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V13C1 13.5304 1.21071 14.0391 1.58579 14.4142C1.96086 14.7893 2.46957 15 3 15Z'
                  stroke='white'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
              {t('Get in Touch')}
            </a>
          </div>

          <div className='col-12 col-lg-6 py-0 py-md-5'>
            <h3>{t(sectionTitle)}</h3>
            <p className='my-4'>{t(sectionDescription)}</p>
            {cards.map((card, index) => (
              <ExpandableCard
                key={index}
                title={t(card.title)}
                content={t(card.description)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhyChooseOurPms;
